import { SuperModel } from './super-model.model';

export class Ticket extends SuperModel {
  ticketId: string;
  rideLabel: string;
  departureDate: string;
  departureTime: string;
  arrivalDate: string;
  arrivalTime: string;
  status: 'notFound' | 'valid';
  reservations: { quantity: number; title: string; icon: string }[];

  get isValid(): boolean {
    return this.status === 'valid';
  }

  constructor(data = {}) {
    super(data);
  }

  get serialised() {
    return {};
  }
}
